<template>
  <div>
    <v-flex>
      <v-card>
        <v-layout row wrap>
          <v-flex xs12 sm4 p-t-20>
            <fieldset>
              <legend>Fornecedor Tipo</legend>
              <v-layout row wrap>
                <v-flex col xs12 v-if="model.tipFornecedor=='J'">
                  <v-switch
                    :readonly="true"
                    v-model="model.tipFornecedor"
                    :label="$t('label.pessoaJurica')"
                    color="info"
                    value="J"
                    hide-details
                  ></v-switch>
                </v-flex>
                <v-flex col xs12 v-else>
                  <v-switch
                    :readonly="true"
                    v-model="model.tipFornecedor"
                    :label="$t('label.pessoaFisica')"
                    color="info"
                    value="F"
                    hide-details
                  ></v-switch>
                </v-flex>
              </v-layout>
            </fieldset>
          </v-flex>
          <v-flex xs12 sm3 p-t-20>
            <fieldset>
              <legend>Nacionalidade</legend>
              <v-layout row wrap>
                <v-flex col xs12 v-if="model.flagEstrangeiro==0">
                  <v-switch
                    :readonly="true"
                    v-model="model.flagEstrangeiro"
                    label="Brasileiro"
                    color="info"
                    value="0"
                    hide-details
                  ></v-switch>
                </v-flex>
                <v-flex col xs12 v-else>
                  <v-switch
                    :readonly="true"
                    v-model="model.flagEstrangeiro"
                    label="Estrangeiro"
                    color="info"
                    value="1"
                    hide-details
                  ></v-switch>
                </v-flex>
              </v-layout>
            </fieldset>
          </v-flex>

          <v-flex xs12 sm5 p-t-20>
            <fieldset>
              <legend>Tipo de Cadastro</legend>
              <v-flex xs12 sm12>
                <v-select
                  v-model="model.tipoCertificado"
                  :items="enumtipoCertificadoFiltrado"
                  item-text="descricao"
                  item-value="valor"
                  :label="$t('Tipo de Cadastro') + ' *'"
                  :rules="validacao.campoObrigatorio"
                  :readonly="model.flagEstrangeiro == 1"
                ></v-select>
              </v-flex>
              <v-flex xs12> </v-flex>
            </fieldset>
          </v-flex>
        </v-layout>
        <v-layout row></v-layout>
        <v-layout row wrap p-t-20>
          <v-flex xs12 sm4>
            <v-text-field
              v-if="model.flagEstrangeiro == 0"
              :readonly="true"
              v-model="model.numCgcFornecedor"
              :label="
                model.tipFornecedor == 'J'
                  ? $t('label.cnpj') + ' *'
                  : $t('label.cpf') + ' *'
              "
              v-mask="model.tipFornecedor == 'J' ? maskCnpj : maskCpf"
              :rules="
                model.tipFornecedor == 'J' ? validacao.cnpj : validacao.cpf
              "
              required
            ></v-text-field>
            <v-text-field
              v-if="model.flagEstrangeiro == 1"
              :readonly="true"
              v-model="model.numCgcFornecedor"
              :label="
                model.tipFornecedor == 'J'
                  ? $t('label.registro')
                  : $t('label.passaporte')
              "
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm8>
            <v-text-field
              v-model="model.nomFornecedor"
              maxlength="70"
              :label="
                model.tipFornecedor == 'J'
                  ? $t('label.razaoSocial') + ' *'
                  : $t('label.nome') + '*'
              "
              :rules="validacao.campoObrigatorio"
              required
              @change="limpaCampo(['arquivoUpload', 'datExpedicao'])"
              validate-on-blur
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs12>
            <v-text-field
              v-if="model.tipFornecedor == 'J'"
              maxlength="70"
              v-model="model.nomFantasia"
              @change="limpaCampo(['arquivoUpload', 'datExpedicao'])"
              :label="$t('label.nomeFantasia')"
            ></v-text-field>
            <v-text-field
              v-else
              ref="nomSocial"
              v-model="model.nomSocial"
              maxlength="70"
              :label="$t('label.nomeSocial')"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap p-t-20>
           <v-flex xs12 :sm4="model.finalidadeEmpresa === 1" :sm6="model.finalidadeEmpresa !== 1">
            <v-select
              v-model="model.categoria"
              :items="listaCategoria"
              item-text="descricao"
              item-value="categoria"
              :label="$t('label.categoria') + ' *'"
              :rules="validacao.campoObrigatorio"
              :readonly="model.flagEstrangeiro == 1"
            ></v-select>
          </v-flex>

          <v-flex xs12 :sm4="model.finalidadeEmpresa === 1" :sm6="model.finalidadeEmpresa !== 1" p-t-1 v-if="model.tipFornecedor == 'J'">
            <v-select
              v-model="model.finalidadeEmpresa"
              :items="enumTipoFinalidadeEmpresa"
              item-text="descricao"
              item-value="valor"
              :label="$t('label.finalidadeEmpresa') + ' *'"
              :rules="validacao.finalidadeEmpresa"              
              required
            ></v-select>
          </v-flex>

          <v-flex xs12 sm4 v-if="model.finalidadeEmpresa === 1">
            <v-checkbox v-model="flagSociedadeAnonima" label="Sociedade Anônima?"></v-checkbox>
          </v-flex>

        </v-layout>
        
        <v-layout
          v-if="model.tipFornecedor == 'F' && documentoRG.docSolicitacao"
          row
        >
          <v-flex xs12 sm12>
            <fieldset>
              <legend>Documento de Identificação</legend>
              <v-layout row wrap>
                <v-flex xs12 sm6 md4 v-if="model.flagEstrangeiro == 0">
                  <v-text-field
                    v-model="documentoRG.docSolicitacao.numDocumentoForn"
                    maxlength="11"
                    @change="
                      limpaCampo(['arquivoUpload']);
                      isAlteracao ? (upload.novoRG = true) : true;
                    "
                    :label="$t('label.rg') + ' *'"
                    :rules="ObrigaCampo(validacao.campoRG)"
                    @keyup="campoRG()"
                    required
                    validate-on-blur
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4 v-if="model.flagEstrangeiro == 0">
                  <datePicker
                    v-model="documentoRG.docSolicitacao.datExpedicao"
                    :key="keyDataExpedicao"
                    v-mask="maskData"
                    :limitarData="true"
                    :dataDefault="documentoRG.docSolicitacao.datExpedicao"
                    :rules="ObrigaCampo()"
                    :label="$t('label.dataExpedicao') + ' *'"
                  />
                </v-flex>
                <v-flex xs12 sm6 md4 v-if="model.flagEstrangeiro == 0">
                  <v-text-field
                    v-model="documentoRG.docSolicitacao.nomOrgaoEmissor"
                    maxlength="40"
                    @change="
                      limpaCampo(['arquivoUpload']);
                      isAlteracao ? (upload.novoRG = true) : true;
                    "
                    :label="$t('label.orgaoEmissor') + ' *'"
                    :rules="ObrigaCampo()"
                    required
                  ></v-text-field>
                </v-flex>

              <v-flex inputIcon xs12 sm6 md12 v-show="!upload.novoRG">
              <v-text-field
                :key="documentoRG.docSolicitacao.arquivoUpload === null ? Math.random() : documentoRG.docSolicitacao.arquivoUpload"
                :value="subStrUpload(documentoRG.docSolicitacao.arquivoUpload, $t('label.documentoIdentificacao'))"
                :label="$t('label.anexarDocumentoIdentidade')"
                clearable
                append-icon="get_app"
                readonly
                @click:append="baixarArquivo(documentoRG.docSolicitacao.arquivoUpload)"
                @click:clear="limparRG"    
              />
            </v-flex>

              <v-flex xs12 sm6 md12 v-if="upload.novoRG" :key="keyAnexoRG">
                <uploadFile
                  tamanhoMaximo="20MB"
                  :required="upload.novoRG"
                  :label="$t('label.anexarDocumentoIdentidade') + ' *'"
                  v-model="documentoRG.file"
                  accept=".pdf, .PDF"
                />
              </v-flex>
              </v-layout>
            </fieldset>
          </v-flex>
        </v-layout>

        <v-layout wrap>
          <v-flex xs12 sm6 md4>
            <v-text-field
              v-model="model.endEmail"
              maxlength="50"
              :label="$t('label.email') + ' *'"
              :rules="validacao.email"
              required
              validate-on-blur
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-text-field
              v-model="model.endEmail2"
              maxlength="50"
              :label="$t('label.emailAdicional')"
              :rules="validacao.emailValid"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-text-field
              v-model="model.endEmail3"
              maxlength="50"
              :label="$t('label.emailAdicional')"
              :rules="validacao.emailValid"
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md12>
            <v-text-field
              v-model="model.nomContato"
              maxlength="200"
              :label="$t('label.nomeContato') + ' *'"
              :rules="ObrigaCampo()"
              required
              validate-on-blur
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 sm4>
            <v-text-field
              v-if="model.flagEstrangeiro == 0"
              key="telefoneComMask"
              maxlength="14"
              v-model="model.numTelefone"
              :label="$t('label.telefone') + ' *'"
              v-mask="maskTelefone"
              :rules="validacao.campoTelefone"
              required
              validate-on-blur
            ></v-text-field>
            <v-text-field
              v-if="model.flagEstrangeiro == 1"
              key="telefoneSemMask"
              maxlength="14"
              v-model="model.numTelefone"
              :label="$t('label.telefone') + ' *'"
              :rules="ObrigaCampo()"
              required
              validate-on-blur
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
              v-if="model.flagEstrangeiro == 0"
              key="celularComMask"
              maxlength="19"
              v-model="model.numCelular"
              :label="$t('label.celular') + ' *'"
              v-mask="maskCelular"
              :rules="validacao.campoCelular"
              required
              validate-on-blur
            ></v-text-field>
            <v-text-field
              v-if="model.flagEstrangeiro == 1"
              key="celularSemMask"
              maxlength="24"
              minlength="13"
              v-model="model.numCelular"
              :label="$t('label.celular') + ' *'"              
              :rules="validacao.campoCelularEst"
              validate-on-blur
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
              v-if="model.flagEstrangeiro == 0"
              key="faxComMask"
              maxlength="14"
              v-model="model.numFax"
              :label="$t('label.telefoneAdicional')"
              v-mask="maskTelefone"
              :rules="validacao.campoTelefoneAdicional"
              validate-on-blur
            ></v-text-field>
            <v-text-field
              v-if="model.flagEstrangeiro == 1"
              key="faxSemMask"
              maxlength="14"
              v-model="model.numFax"
              :label="$t('label.telefoneAdicional')"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <!-- Removido temporariamente-->
            <v-text-field
              v-if="model.flagEstrangeiro == 0 && 1 == 2"
              key="faxComMask"
              maxlength="14"
              v-model="model.numFax"
              :label="$t('label.fax')"
              v-mask="maskTelefone"
              :rules="validacao.campoFax"
              validate-on-blur
            ></v-text-field>
            <v-text-field
              v-if="model.flagEstrangeiro == 1"
              key="faxSemMask"
              maxlength="14"
              v-model="model.numFax"
              :label="$t('label.fax')"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-layout row wrap>
      <v-flex xs12 p-t-30>
        <h2 class="headline mb-0 text-primary">
          <strong>{{ $t("label.endereco") }}</strong>
        </h2>
      </v-flex>
    </v-layout>
    <v-flex p-t-30>
      <v-card>
        <v-layout row wrap>
          <v-flex xs8 sm10>
            <v-text-field
              v-model="model.endLogradouro"
              @change="limpaCampo(['arquivoUpload', 'datExpedicao'])"
              maxlength="50"
              :label="$t('label.logradouro') + ' *'"
              :rules="ObrigaCampo()"
              required
              validate-on-blur
            ></v-text-field>
          </v-flex>
          <v-flex xs4 sm2>
            <v-text-field
              v-model="model.endNumero"
              maxlength="6"
              @change="limpaCampo(['arquivoUpload', 'datExpedicao'])"
              :label="$t('label.numero') + ' *'"
              :rules="ObrigaCampo()"
              required
              validate-on-blur
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-text-field
              @change="limpaCampo(['arquivoUpload', 'datExpedicao'])"
              v-model="model.endComplemento"
              maxlength="25"
              :label="$t('label.complemento')"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-text-field
              v-model="model.endBairro"
              maxlength="100"
              @change="limpaCampo(['arquivoUpload', 'datExpedicao'])"
              :label="$t('label.bairro') + ' *'"
              :rules="ObrigaCampo()"
              required
              validate-on-blur
            ></v-text-field>
          </v-flex>
          
          <!-- CEP com consulta ao webservice -->
          <v-flex xs12 sm6 md4>
            <div
              v-if="validEventCEP"
              class="msgCEPbasico v-messages v-messages__message theme--light error--text"              
            >
              {{ this.cepNaoEnc }}
            </div>
            <v-text-field
              v-if="model.flagEstrangeiro == 0"
              v-model="model.endCep"
              @change="limpaCampo(['arquivoUpload', 'datExpedicao'])"
              :label="$t('label.cep') + ' *'"
              v-mask="maskCEP"
              :rules="validacao.campoCep"
              required
              validate-on-blur
              @blur="viaCEP()"
              @focus="limpaCEP()"
            ></v-text-field>
            
            <v-text-field
              v-if="model.flagEstrangeiro == 1"
              maxlength="15"
              key="cepSemMask"
              v-model="model.endCepEstrangeiro"
              :label="$t('label.cep')"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-autocomplete
              :disabled="model.flagEstrangeiro == 0 ? true : false"
              v-model="model.codPais"
              :items="listaPais"
              :label="$t('label.pais') + ' *'"
              item-text="nomPais"
              item-value="cod_Pais"
              :rules="validacao.campoObrigatorio"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-autocomplete
              v-if="model.flagEstrangeiro == 0"
              v-model="model.codUf"
              :items="listaEstado"
              :label="$t('label.estado') + ' *'"
              item-text="nom_uf"
              item-value="cod_uf"
              :rules="validacao.campoObrigatorio"
              @change="listaCidade = []"
            ></v-autocomplete>
            <v-text-field
              v-if="model.flagEstrangeiro == 1"
              maxlength="40"
              v-model="model.nomUFEstrangeira"
              :label="$t('label.estado') + ' *'"
              :rules="validacao.campoObrigatorio"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-autocomplete
              v-if="model.flagEstrangeiro == 0"
              v-model="model.endCidade"
              :items="listaCidade"
              :label="$t('label.cidade') + (model.codUf !== 'DF' ? ' *' : '' )"
              item-text="desc_municipio"
              item-value="desc_municipio"
              :rules="validaCidade(model.codUf)"
              :clearable="true"
              :loading="isLoadCombo"
              :search-input.sync="pesquisaCidade"
            ></v-autocomplete>
            <v-text-field
              v-if="model.flagEstrangeiro == 1"
              maxlength="50"
              v-model="model.nomCidadeEstrangeira"
              :label="$t('label.cidade')"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>

    <dialogObservacao
      :config="modalDialogMotivo"
      :persistent="true"      
       :rules="[
          v => (v ? v.length <= 255 : true) || 'Máximo de 255 caracteres',
          ...(isAlteracao && model.tipoCertificado > OldModel.tipoCertificado
            ? validacao.campoObrigatorio
            : [])
        ]"
      v-on:observacaoOk="modalMotivoOk()"
      v-on:observacaoCancel="modalMotivoCancel()"
    />
  </div>
</template>
<script>
import axios from "axios";
import util from "../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import dominioService from "../../services/dominioService";
import fornecedorService from "../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
export default {
  name: "dados-basicos",
  mixins: [util],
  props: {
    //Propriedades que o objeto recebe como parametro
    model: Object /*Solicitacao atual do Fornecedor*/,
    upload: Object,
    acaoTela: String,
    isAlteracao: Boolean,
    OldModel: Object,
    enums: Object,
    fornecedorDeclaracaoVm: Object,
    listaDocFornecSolicitacao: Array,
  },
 
  watch: {   
    //Propriedades assistidas
    model: function (val) {
      this.carregarFlagSociedadeAnonima(val);
      this.getTipoCertificados();
      if (this.model.flagEstrangeiro === "1") {
        this.model.tipoCertificado = 3; // tipo de cadastro é credenciamento
        this.model.categoria = "NO"; // categoria é Normal
        this.model.codUf = null; // codigo UF é null
      }

      if (this.model.flagEstrangeiro === "0") {
    
        if (this.model.endCep) {
          this.model.endCep = this.model.endCep.replace("-", "").replace(".", "");
          this.model.endCep = this.adcionaZeroEsquerda(this.model.endCep, true);
        }
      }
        
    },

    "model.tipFornecedor": {
      //se o tipo de fornecedor mudar
      handler(newValue, oldValue) {
        if (!newValue) {
          if (oldValue === "J") {
            this.model.tipFornecedor = "F";
          } else {
            this.model.tipFornecedor = "J";
          }
        }
      },
    },

    "model.categoria": {
      //se a categoria mudar
      handler(newValue, oldValue) {
        if (oldValue && newValue !== oldValue) {
          this.limpaDeclaracao();
        }
      },
    },

    "model.tipoCertificado": {
      //se o tipo de certificado mudar
      handler(newValue, oldValue) {
        if (this.isAlteracao && oldValue && newValue !== oldValue) {
          if (newValue === this.OldModel.tipoCertificado) {
            this.modalDialogMotivo.obs = null;
            this.model.motivoAlteracaoCertificado = null;
          } else {
            this.modalDialogMotivo.open = true;
          }
          this.oldCertificado = oldValue;
        }
      },
    },

    "model.flagEstrangeiro": {
      handler(newValue, oldValue) {
        if (newValue === "0") {
          this.model.codPais = 1058;
        }

        if (!newValue) {
          if (oldValue === "0") {
            this.model.flagEstrangeiro = "1";
          } else {
            this.model.flagEstrangeiro = "0";
            this.model.codPais = 1058;
          }
        }
      },
    },
    flagSociedadeAnonima: function (val) {
      this.model.flagSociedadeAnonima = val === true ? "1" : "0";
    },

    "model.finalidadeEmpresa": {
       handler(newValue) {
         if(newValue === 0) {
           this.flagSociedadeAnonima = false;
         }
      },
    },
    "model.endCidade": {
      //se a cidade mudar
      handler(newValue, oldValue) {
        if (this.model.flagEstrangeiro !== "1") {
          // flagEstrangeiro é um tipo string
          this.getCidade(newValue);
        }
        if (
          oldValue &&
          oldValue !== newValue &&
          this.model.tipFornecedor === "J"
        ) {
          if (this.isAlteracao) {
            this.limpaCampo(["arquivoUpload", "datExpedicao"]);
          }
        }
      },
    },

    "model.codPais": {
      //se o pais mudar
      handler(newValue, oldValue) {
        if (oldValue && oldValue !== newValue) {
          if (this.isAlteracao) {
            this.limpaCampo(["arquivoUpload", "datExpedicao"]);
          }
        }
      },
    },
    "model.dataExpedicaoRg": {
      //se mudar a data de expedicao
      handler(newValue, oldValue) {
        if (oldValue && !this.verificaDataIguais(oldValue, newValue)) {
          if (this.isAlteracao) {
            this.limpaCampo(["arquivoUpload"]);
            this.upload.novoRG = true;
          }
        }
      },
    },
    listaDocFornecSolicitacao: {
      //se a lista de documentos mudar
      handler(newValue, oldValue) {
        if (newValue) {
          this.documentoRG = this.listaDocFornecSolicitacao.find(
            (x) => x.codDocumento == 140
          );
        }
      },
    },
    pesquisaCidade(newValor, oldValor) {
      //pesquisar a cidade
      this.pesquisaCombo(
        newValor,
        oldValor,
        "listaCidade",
        eval("this.listaCidade"),
        "model.desc_municipio",
        this.getCidade
      );
    },
  },
  computed: {
    //Campos computados
    mostraCredenciamento() {
      //verificar se deve aparecer a opção de credenciamento
      if (this.isAlteracao && this.OldModel.tipoCertificado !== 3) {
        return false;
      }
      return true;
    },
    
  },
  created() /*Metodo de start do componente*/ {
    this.getCombosDadosBasicos();
    this.getFinalidadeEmpresa();
    this.getTipoCertificados();
    // Se for estrangeiro
  },
  data() {
    
    //Declaracao de variaveis
    return {
      keyAnexoRG: 1,
      keyDataExpedicao: 1,
      novoRG: false,
      active: 0,
      oldCertificado: null,
      valid: true,
      validModalDialogMotivo: true,
      repitaSenha: "",
      listaCategoria: [],
      listaPais: [],
      listaEstado: [],
      listaCidade: [],
      pesquisaCidade: null,
      isLoadCombo: false,
      modalDialogMotivo: {
        open: false,
        titulo: "Motivo da Alteração",
        labelBtnOk: "Ok",
      },
      enumtipoCertificado: [],
      enumtipoCertificadoFiltrado: [],
      enumTipoFinalidadeEmpresa: null,
      documentoRG: Object,
      flagSociedadeAnonima: false,
      baseUrlCEP: "https://viacep.com.br/ws/",
      cepNaoEnc: "CEP não encontrado.",
      validEventCEP: false
    };
  },

  methods: {
    //Declaracao de todos os metodos
    ObrigaCampo(tipo) {
      //obriga o campo
      if (tipo) {
        return tipo;
      } else {
        return this.validacao.campoObrigatorio;
      }
    },
  limparRG() {
      setTimeout(() => {
        this.upload.novoRG = true;
        this.documentoRG.docSolicitacao.arquivoUpload = null;
        this.documentoRG.file = null;
      }, 0);
    },
    carregarFlagSociedadeAnonima(model) {
      this.flagSociedadeAnonima = (model.flagSociedadeAnonima === "1" || model.flagSociedadeAnonima === 1);
    },
    getCombosDadosBasicos() {
      //carregar combo de dados basicos
      dominioService.getCombosDadosBasicos().then((response) => {
        /*resposta do servico*/
        this.listaCategoria = response.data.categoria;

        // flagEstrangeiro é um tipo string
        if (this.model.flagEstrangeiro !== "1") {
          // se não for estrangeiro, carrega a lista de estados brasileiros
          this.listaEstado = response.data.uf;
        }
        this.listaPais = response.data.paises;
      });
    },

    getFinalidadeEmpresa() {
      //pegar as possiveis finalidade de empresa
      dominioService.geEnums().then((response) => {
        /*resposta do servico*/
        this.enumTipoFinalidadeEmpresa = response.data.tipoFinalidadeEmpresa;
      });
    },

     getTipoCertificados() {
      let certificadoSimpas = null;
      let cgcFornecedor = this.model.numCgcFornecedor != null ? this.model.numCgcFornecedor.replace(/[\W_]+/g, "") : null;
      
      fornecedorService.getTipoCertificadoCasdastradoSimpas(cgcFornecedor).then((response) => {
        certificadoSimpas = response.data;
      }).finally(() => {
        //pegar as possiveis Tipo certificados de empresa
        dominioService.geEnums().then((response) => {
          /*resposta do servico*/
          this.enumtipoCertificado = response.data.tipoCertificado;
          this.enumtipoCertificadoFiltrado = [];

          if (this.model.tipFornecedor == "J") {
            this.enumtipoCertificadoFiltrado = this.enumtipoCertificado;
          }  else {
            this.enumtipoCertificado.forEach((item) => {
              // Remove o tipo CRC com Id: 1 quando o tipo do fornecedor é CPF
              if (item.valor != "1") this.enumtipoCertificadoFiltrado.push(item);
            });
          }

          // Situações permitidas para alteração para Candidato
          const situacoesPermitidas = [1, 2, 3, 4, 5, 6];

          if (
            [1, 2].includes(certificadoSimpas) &&
            !situacoesPermitidas.includes(this.model.situacaoSolicitacao)
          ) {
            this.enumtipoCertificadoFiltrado = this.enumtipoCertificadoFiltrado.filter(x => x.valor != 3);
          }
        });
      }); 
    },

    getCidade(valor) {
      //resgatar a lista de cidades
      this.isLoadCombo = true;
      // #130751 O valor está sendo passado vazio por causa que na consulta tem que retornar todos para o filtro ser feito pelo campo
      let cidade = { cod_uf: this.model.codUf, desc_municipio: "" };
      dominioService.getCidade(cidade).then((response) => {
        /*resposta do servico*/
        this.listaCidade = response.data; /*dados de retorno*/
        this.isLoadCombo = false;
      });
    },

    baixarArquivo(arquivo) {
      //baixar o documento
      const numCgcFornecedor = this.$verificaPerfilCadastrador()
        ? this.model.numCgcFornecedor.replace(/[\W_]+/g, "")
        : null;
      fornecedorService.baixarArquivo(arquivo, numCgcFornecedor);
    },

    modalMotivoCancel() {
      //abrir modal de motivo de indeferimento
      this.model.tipoCertificado = this.oldCertificado;
      setTimeout(() => {
        this.modalDialogMotivo.open = false;
      }, 1);
    },

    modalMotivoOk() {
      //confirmação do motivo de indeferimento
      this.model.motivoAlteracaoCertificado = Object.freeze(
        this.modalDialogMotivo.obs
      );
      this.modalDialogMotivo.open = false;
    },

    limpaCampo(campos, campofile) {
      //limpar os campos do documento
      if (this.isAlteracao) {
        if (Array.isArray(campos)) {
          campos.forEach((campo) => {
            this.limpaRG(campo);
          });
        } else {
          this.limpaRG(campo);
        }
      }
    },

    // limpa os campos do RG
    limpaRG(campo) {
      if (this.documentoRG.docSolicitacao[campo]) {
        this.documentoRG.docSolicitacao[campos] = null;
      }
      if (
        campo === "arquivoUpload" &&
        this.documentoRG.docSolicitacao[campo] == null
      ) {
        this.keyAnexoRG++;
      }
      if (
        campo === "datExpedicao" &&
        this.documentoRG.docSolicitacao[campo] == null
      ) {
        this.keyDataExpedicao++;
      }
    },

    limpaDeclaracao() {
      //limpar o documento de declaracao de enquadramento da aba de formulario e declaracoes
      if (this.isAlteracao) {
        var cod = this.enums.tipoUploadDeclaracao.find(
          (x) => x.chave === "DeclaracaoEnquadramento"
        );
        if (cod) {
          this.model.uploadDeclaracao = this.model.uploadDeclaracao.filter(
            (x) => {
              return x.tipDocumento !== cod.valor;
            }
          );

          this.fornecedorDeclaracaoVm.lista = this.fornecedorDeclaracaoVm.lista.filter(
            (x) => {
              return false;
            }
          );
        }
      }
    },

    validaCidade(estado){
      return estado !== 'DF' ? this.validacao.campoObrigatorio : [];
    },
    
    campoRG() {
      this.documentoRG.docSolicitacao.numDocumentoForn = this.documentoRG.docSolicitacao.numDocumentoForn.replace(
        /[^\d]+/g,
          ""
        );
    },

    limpaCEP() {
      this.validEventCEP = false
    },    

    viaCEP() {           
      const setCEP = this.model.endCep.replace("-", "").replace(".", ""); // Removendo máscara de CEP
      const urlCEP = `${this.baseUrlCEP}${setCEP}/json/`;
      
      axios.get(urlCEP).then(resp => {
        const data = resp.data
        if (!data.erro) {
          this.model.endLogradouro = data.logradouro,
          this.model.endBairro = data.bairro,
          this.model.endCidade = data.localidade,
          this.model.codUf = data.uf
        } else {
          this.validEventCEP = data.erro,
          this.model.endLogradouro = null,
          this.model.endBairro = null,
          this.model.endCidade = null,
          this.model.codUf = null
        }
      }).catch(error => {
        console.error(error)
      })
    }
  },
};
</script>

<style>
.inputIcon {
  position: relative;
}

.inputIcon [type="file"] {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
}

.inputIcon .v-input__append-inner {
  margin-top: 0;
  padding-left: 0;
  text-align: center;
  width: 38px;
}

.inputIcon .v-text-field__slot {
  border-right: 0;
}

.inputIcon .v-input__icon--clear {
  border-radius: 0;
  border-right: 0 none !important;
}

.inputIcon .v-input__icon {
  align-self: center !important;
  min-height: 50px;
  border: solid 1px #eee;
  border-left: none;
  border-bottom: none;
  display: inline-block !important;
  vertical-align: middle !important;
}

.inputIcon .v-icon {
  padding: 13px 0 0 0;
}

.msgCEPbasico {
  position: absolute !important;
  top: 165px !important;
}
</style>
